import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../components/ui/card";
import ShadcnPageWrapper from "./ShadcnPageWrapper";

export default function ConfirmPW() {
  return (
    <ShadcnPageWrapper>
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-slate-100">
        <div className="w-full sm:w-[400px]">
          <div className="mb-6 flex flex-col items-center gap-2">
            <img src="/images/g1313.png" alt="삼성중공업" className="h-10 w-auto" />
            <h1 className="m-0 text-xl font-bold text-foreground">
              삼성중공업 하이테크 통합 DP 시스템
            </h1>
          </div>

          <Card>
            <CardHeader className="items-center text-center">
              <CardTitle className="text-base no-underline">
                비밀번호가 변경되었습니다.
              </CardTitle>
              <CardDescription>새 비밀번호로 다시 로그인해주세요.</CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col items-center gap-6">
              <img src="/images/ok.png" className="max-h-[300px] max-w-full" alt="" />
              <Button
                asChild
                className="w-full border-0 bg-[hsl(222,80%,40%)] text-white hover:bg-[hsl(222,80%,40%)]/80"
              >
                <RouterLink to={{ pathname: "/dplogin" }} className="no-underline">
                  로그인
                </RouterLink>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </ShadcnPageWrapper>
  );
}
